<template>
  <div class="col">
    <div
      class="col p-2"
      style="position: relative"
    >
      <profile-header :userData="getUserData">
      </profile-header>
      <span style="position: absolute; bottom: 13px;right: 13px">
        <router-link :to="{path: '/user/profile',
                          query: {
                              display_text: 'My Profile',
                            }
                          }"
																					data-test="accountProfileLink"
																					id="accountProfileLink">
          <i class="fas fa-pen"
													data-test="accountProfileIcon"
													id="accountProfileIcon"></i>
        </router-link>
      </span>
    </div>
    <div>
      <div class="col mb-3 border p-0 wp_myRegionSelector">
        <div class="wp_accountMogileMyRegionContainer">
          <button
            class="accordion"
            id="wp_accordion_panel_my_region_button"
            @click.prevent="myRegionToggler"
												data-test="accountRegionBtn"
          >
            <h5 data-test="accountRegionHead"
																id="accountRegionHead">My Region</h5>
          </button>
          <div
            class="panel"
            id="wp_accordion_panel_my_region"
          >
            <country-picker @closeMyRegion="myRegionToggler">
            </country-picker>
          </div>
        </div>
      </div>
      <!--Pay Later Informer-->
      <!--<div class="col mb-3 border p-0 wp_due_wrapper">-->
      <!--<div class="wp_due">-->
      <!--<button class=""-->
      <!--&gt;-->
      <!--<h5>Due: $11,788</h5>-->
      <!--</button>-->
      <!--</div>-->
      <!--</div>-->
      <div
        class="col p-4 mb-3 border"
        style="background-color: #fff"
        v-for="(route, index) in routes"
        :key="index"
      >
        <h5 v-if="route.name !== 'Gift Card'"
												:data-test="'accountGiftcardHeadLink1'+index"
												:id="'accountGiftcardHeadLink1'+index">My {{route.name}}</h5>
        <h5 v-if="route.name === 'Gift Card'"
												:data-test="'accountGiftcardHeadLink2'+index"
												:id="'accountGiftcardHeadLink2'+index">{{route.name}}</h5>
        <div class="border-top pb-3"></div>
        <span
          class="accountLink"
          v-if="route.name !== 'Gift Card'"
										:data-test="'accountRedirectGiftcardSpan'+index"
										:id="'accountRedirectGiftcardSpan'+index"
        >
          <router-link
            :to="route.to"
            tag="a"
												:data-test="'accountRedirectGiftcardLink'+index"
												:id="'accountRedirectGiftcardLink'+index"
          >
            Go to My {{route.name}}
          </router-link>
        </span>
        <span
          class="accountLink"
          v-if="route.name === 'Gift Card'"
										:data-test="'accountCreateGiftcardSpan'+index"
										:id="'accountCreateGiftcardSpan'+index"
        >
          <router-link
            :to="route.to"
            tag="a"
												:data-test="'accountCreateGiftcardLink'+index"
												:id="'accountCreateGiftcardLink'+index"
          >
            Create {{route.name}}
          </router-link>
        </span>
      </div>
      <!--<div class="col p-4 mb-3 border" style="background-color: #ebebeb">-->
      <!--<h5>My Cart</h5>-->
      <!--<div class="border-top pb-3"></div>-->
      <!--<span class="accountLink">-->
      <!--<router-link to="/cart"-->
      <!--tag="a"-->
      <!--&gt;-->
      <!--Go to My Cart-->
      <!--</router-link>-->
      <!--</span>-->
      <!--</div>-->
      <!--<div class="col p-4 mb-3 border" style="background-color: #ebebeb">-->
      <!--<h5>My Wishlist</h5>-->
      <!--<div class="border-top pb-3"></div>-->
      <!--<span class="accountLink">-->
      <!--<router-link to="/user/wish-list"-->
      <!--tag="a"-->
      <!--&gt;-->
      <!--Go to My Wishlist-->
      <!--</router-link>-->
      <!--</span>-->
      <!--</div>-->
      <!--<div class="col p-4 mb-3 border" style="background-color: #ebebeb">-->
      <!--<h5>My Address</h5>-->
      <!--<div class="border-top pb-3"></div>-->
      <!--<span class="accountLink">-->
      <!--<router-link to="/user/addresses"-->
      <!--tag="a"-->
      <!--&gt;-->
      <!--Go to My Addresses-->
      <!--</router-link>-->
      <!--</span>-->
      <!--</div>-->
    </div>
    <ul class="border p-4">
      <li class="row">
        <div class="icon icon--s">
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 471.2 471.2"
            style="enable-background:new 0 0 471.2 471.2;"
            xml:space="preserve"
												data-test="accountLogoutSvg"
          >
            <g>
              <g>
                <path d="M227.619,444.2h-122.9c-33.4,0-60.5-27.2-60.5-60.5V87.5c0-33.4,27.2-60.5,60.5-60.5h124.9c7.5,0,13.5-6,13.5-13.5
			s-6-13.5-13.5-13.5h-124.9c-48.3,0-87.5,39.3-87.5,87.5v296.2c0,48.3,39.3,87.5,87.5,87.5h122.9c7.5,0,13.5-6,13.5-13.5
			S235.019,444.2,227.619,444.2z"></path>
                <path d="M450.019,226.1l-85.8-85.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1l62.8,62.8h-273.9c-7.5,0-13.5,6-13.5,13.5
			s6,13.5,13.5,13.5h273.9l-62.8,62.8c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8
			C455.319,239.9,455.319,231.3,450.019,226.1z" />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>

        </div>
        <div>
          <a
            href="#"
            @click="logout"
												data-test="accountLogoutLink"
												id="accountLogoutLink"
          >
            LogOut
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import CountryPicker from '@/components/shared/widgets/CountryPicker'
import { mapGetters } from 'vuex'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import ProfileHeader from './ProfileHeader'
import eventService from '../../../../services/DomEventServices/domEventServices'

export default {
	name: 'account',
	components: {
		ProfileHeader,
		CountryPicker
	},
	computed: {
		...mapGetters('user', ['getUserData'])
	},
	data () {
		return {
			routes: [
				{
					name: 'Orders',
					to: {
						path: '/user/orders',
						query: {
							display_text: 'My Orders'
						}
					}
				},
				{
					name: 'Cart',
					to: {
						path: '/cart',
						query: {
							display_text: 'My Cart'
						}
					}
				},
				{
					name: 'Wishlist',
					to: {
						path: '/user/wish-list',
						query: {
							display_text: 'My Wishlist'
						}
					}
				},
				{
					name: 'Addresses',
					to: {
						path: '/user/addresses',
						query: {
							display_text: 'My Addresses'
						}
					}
				},
				{
					name: 'Gift Card',
					to: {
						path: '/user/giftCards',
						query: {
							display_text: 'Gift Cards'
						}
					}
				}
				// {
				//   name: 'SavedCards',
				//   to: '/user/saved-cards',
				// },
			]
		}
	},
	methods: {
		logout () {
			authenticationApi.logOut().then((res) => {
				this.$router.push('/')
			})
		},
		myRegionToggler () {
			// let panel = document.getElementById('wp_accordion_panel_my_region');
			// // let acc = document.getElementById('wp_accordion_panel_my_region_button');
			// // acc.classList.toggle("active");
			// if (panel.style.display === "block") {
			//   panel.style.display = "none";
			// } else {
			//   panel.style.display = "block";
			// }
			eventService.accordionToggler('wp_accordion_panel_my_region')
		}
	}
}

</script>

<style scoped>
</style>
